import { render, staticRenderFns } from "./Lgx201394311844069376.vue?vue&type=template&id=5bca562e&scoped=true&"
import script from "./Lgx201394311844069376.vue?vue&type=script&lang=js&"
export * from "./Lgx201394311844069376.vue?vue&type=script&lang=js&"
import style0 from "./Lgx201394311844069376.vue?vue&type=style&index=0&id=5bca562e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca562e",
  null
  
)

export default component.exports